export default {
  NA: 0,
  GO: 1,
  SLOW: 2,
  WHOA: 3
};
